import React from 'react';
import EventHero from '../../../subscreens/eventpage/EventHero.js';
import Eventcard from '../../../components/students/eventcard/Eventcard.js';
import Eventschdule from '../../../subscreens/eventpage/Eventschdule.js';
import Eventgallery from '../../../subscreens/eventpage/Eventgallery.js';


const Eventpage = () => {

    return (
        <>
            <EventHero />
            <Eventcard />
            <Eventschdule />
            <Eventgallery />
        </>
    );
}
export default Eventpage;
